import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
    selector: 'topic-builder-share',
    template: `
        <invitation-manager [form]="newUserForm" title="Invite New Members" style="display: block; padding-top: 15px;"></invitation-manager>
        <current-user-invitation-manager [form]="currentUserForm" title="Invite Existing Members" style="display: block; padding-top: 15px;"></current-user-invitation-manager>
    `
})
export class TopicBuilderShareComponent {
    @Input() newUserForm: FormGroup;
    @Input() currentUserForm: FormGroup;
    @Input() selected: boolean;
}